import { render, staticRenderFns } from "./FaceCheck.vue?vue&type=template&id=4b3e5fda&scoped=true"
import script from "./FaceCheck.vue?vue&type=script&lang=js"
export * from "./FaceCheck.vue?vue&type=script&lang=js"
import style0 from "./FaceCheck.vue?vue&type=style&index=0&id=4b3e5fda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3e5fda",
  null
  
)

export default component.exports